import CategoryService from '@/lib/Category';
import { useQuery } from '@tanstack/react-query';
import useCategories from './useCategories';
import useCurrentUser from './useCurrentUser';

// Hook to get Top 25 category stocks
export default function useTop25Stocks() {
  const { data: user } = useCurrentUser();
  const { data: categories } = useCategories();

  // Find the "Top 25" category
  const top25Category = categories?.find((cat: any) => cat.name === 'Top 25');

  const query = useQuery({
    queryKey: ['top25-stocks', top25Category?.id],
    queryFn: () => {
      if (!top25Category?.id) throw new Error('Top 25 category not found');
      return CategoryService.getCategory(String(top25Category.id), true);
    },
    enabled: !!top25Category?.id && !!user,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  return {
    ...query,
    data: query.data?.assets?.slice(0, 10) || [], // Top 10 stocks from Top 25
  };
}
